/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".player-wrap[_ngcontent-%COMP%]{display:-webkit-box;display:flex;height:32rem;border-radius:6px;overflow:hidden}.player-wrap[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{width:100%;-webkit-box-flex:1;flex:1}.modal-body[_ngcontent-%COMP%]{padding:.4rem 0 0}.close-btn[_ngcontent-%COMP%]{background-color:#eee}.close-btn[_ngcontent-%COMP%]:hover{background-color:#ddd}.close-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:2rem}"];
export { styles as styles };
//# sourceMappingURL=speechace-modal.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/speechace-modal/speechace-modal.component.scss.shim.ngstyle.js
// module id = 1297
// module chunks = 27 28 29